import { httpCreate } from './http';

const http = httpCreate('/srv/subscribe-detail');

export const subscribe = {
	// 获取订阅详情
	getSubscribeDetail(activityId, params) {
		return http.get(`/list/${activityId}`, { params });
	},
	// 获取用户回访率
	getUserRote(activityId) {
		return http.get(`/rate/${activityId}`);
	},
};
